import { ItemSourceSentenceTranslationValidatorItemStatus } from 'constants/itemSourceSentenceTranslationValidatorStatus';

export function itemSourceSentenceTranslationValidatorItemStatusRenderer(params: { value?: any }) {
  if (params.value === undefined || params.value === null) {
    return '';
  }

  const status = parseInt(params.value);

  switch (status) {
    case ItemSourceSentenceTranslationValidatorItemStatus.PENDING:
      return '<span class="fa fa-circle-pause" style="color: #ff9800;" title="Pending"></span>';
    case ItemSourceSentenceTranslationValidatorItemStatus.NEEDS_USER_REVIEW:
      return '<span class="fa fa-user" style="color: #2196f3;" title="Needs User Review"></span>';
    case ItemSourceSentenceTranslationValidatorItemStatus.DONE:
      return '<span class="fa fa-check-circle" style="color: #4caf50;" title="Done"></span>';
    default:
      return '';
  }
}